module.exports = __WEBPACK_EXTERNAL_MODULE_96__;


//////////////////
// WEBPACK FOOTER
// external "xes-frontend-ui/lib/mixins/styleMixin"
// module id = 96
// module chunks = 8 11 12